import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Typography } from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import { ReactComponent as AccountCredentialSvg } from '../../../assets/icons/user-account/account-credentials.svg';
import { ReactComponent as ContactPreferenceSvg } from '../../../assets/icons/user-account/contact-preferences.svg';
import { ReactComponent as PersonalInformationSvg } from '../../../assets/icons/user-account/personal-information.svg';

const { Title } = Typography;

const styles = {
  menutItem: {
    width: '100%',
    border: "1px solid #C0C0C0",
    boxSizing: "border-box",
    borderRadius: "2px",
    padding: "14px 24px",
    marginBottom: 20
  },
  hoverMenu: {
    width: '100%',
    border: "1px solid #C0C0C0",
    boxSizing: "border-box",
    borderRadius: "2px",
    padding: "14px 24px",
    backgroundColor: '#DCF2FB',
    color: '#FFF',
    marginBottom: 20
  },
  menuTitle: {
    fontWeight: "300",
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "capitalize",
    color: "#404047",
    margin: 0,
    marginLeft: 10
  }
}

function MobileUserAccountScreen() {
  const { t } = useTranslation(['user-account', 'common']);
  const history = useHistory();

  const menu = [
    {
      icon: <AccountCredentialSvg />,
      title: t('user-account:home.personalInformation'),
      url: '/user-account/personal-information'
    },
    {
      icon: <ContactPreferenceSvg />,
      title: t('user-account:home.contactPreference'),
      url: '/user-account/contact-preference'
    },
    {
      icon: <PersonalInformationSvg />,
      title: t('user-account:home.accountCredential'),
      url: '/user-account/account-credential'
    }
  ]

  const onBack = () => {
    history.push('/homepage')
  }

  const ItemList = ({icon, title, url}) => {
    const [isShown, setIsShown] = useState(false);
    return (
      <Box
        style={isShown ? styles.hoverMenu : styles.menutItem}
        onClick={() => history.push(url)}
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
      >
        <Row justify="start" align="middle">
          {icon}
          <Title level={4} style={styles.menuTitle}>
            {title}
          </Title>
        </Row>
      </Box>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('user-account:home.previousPage')}
        title={t('user-account:home.title')}
        subtitle={t('user-account:home.subtitle')}
      />
      <Box style={{ padding: 0, marginTop: 20 }}>
        {menu.map(({icon, title, url}) => <ItemList icon={icon} title={title} url={url} />)}
      </Box>
    </>
  );
}

export default MobileUserAccountScreen;
